import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import WorldFishRouter from "./components/WorldFish-Router";
import Header from "./components/Header";
import Login from "./components/Login";
import Logout from "./components/Logout";
import ResetPassword from "./components/ResetPassword";
import Login1 from "./components/Login1";
import Register1 from "./components/Register1";
export const AuthContext = React.createContext();
function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return localStorage.getItem("isAuthenticated") === "true";
  });
  const location = useLocation();
  // Define routes where header should be hidden
  const hideHeaderRoutes = ["/login-one", "/register-one", '/home', '/edit-input'];
  const shouldShowHeader = !hideHeaderRoutes.includes(location.pathname);
  useEffect(() => {
    // Check if user is logged in
    const token = localStorage.getItem("isAuthenticated");
    setIsAuthenticated(token === "true");
  }, []);
  const login = () => {
    localStorage.setItem("isAuthenticated", "true");
    setIsAuthenticated(true);
  };
  const logout = () => {
    localStorage.clear(); // This already clears everything, including userDetails
    setIsAuthenticated(false);
  };
  return (
    // <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
    // <Header />
    // <Routes>
    // <Route path="/login" element={<Login />} />
    // <Route path="/login-one" element={<Login1 />} />
    // <Route path="/register-one" element={<Register1 />} />
    // <Route path="/logout" element={<Logout />} />
    // <Route
    // path="/reset-password"
    // element={
    // isAuthenticated ? <Navigate to="/profile" replace /> : <ResetPassword />
    // }
    // />
    // <Route
    // path="/*"
    // element={isAuthenticated ? <WorldFishRouter /> : <Navigate to="/login" />}
    // />
    // </Routes>
    // </AuthContext.Provider>
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {/* Conditionally show header */}
      {shouldShowHeader && <Header />}
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/login-one" element={<Login1 />} />
        <Route path="/register-one" element={<Register1 />} />
        <Route path="/logout" element={<Logout />} />
        <Route
          path="/reset-password"
          element={
            isAuthenticated ? (
              <Navigate to="/profile" replace />
            ) : (
              <ResetPassword />
            )
          }
        />
        <Route
          path="/*"
          element={
            isAuthenticated ? (
              <WorldFishRouter />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
      </Routes>
    </AuthContext.Provider>
  );
}
export default App;